import { TypeFromSchemaValidator } from "../../..";
import { ApiClient } from "../../../api-client";
import { ApiClientError } from "../../../errors";
import schemaValidators from "./schema-validators";

type ConnectionCheckDetails = Omit<
	TypeFromSchemaValidator<(typeof schemaValidators)["connectionCheckEvent"]>["details"],
	"metrics"
> & {
	metrics?: any; // since NetworkInformation doesn't work
};
type ConnectionCheck = Omit<TypeFromSchemaValidator<(typeof schemaValidators)["connectionCheckEvent"]>, "details"> & {
	details: ConnectionCheckDetails;
};
export class SystemLoggerClient extends ApiClient<typeof schemaValidators> {
	constructor(config: ApiClient["config"]) {
		super(config, schemaValidators);
	}

	connectionCheck = async (
		proctoringSessionId: string,
		isCompatibility: boolean,
		details: ConnectionCheck["details"],
	) => {
		try {
			if (proctoringSessionId === "" && isCompatibility) return true;
			const event: ConnectionCheck = {
				type: "system",
				name: "connection check",
				time: new Date(),
				details,
			};
			const resp = await super.fetch(`${this.config.verityOrigin}/api/verity/quiz/event/${proctoringSessionId}`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(event),
				credentials: "include",
			});
			if (resp.ok) {
				return true;
			}
		} catch (error) {
			if (error instanceof Error) {
				throw new ApiClientError(error);
			}
		}
		throw new ApiClientError();
	};
}
